import storefront from "./index";

const PAGE_SIZE = 250;

export function shopifyImageUrl(url, width) {
  if (!url) return url;
  return `${url.split("?")[0]}?width=${width}`;
}

export function shopifyImageSrcset(url, widths = [200, 400, 600, 800, 1200]) {
  if (!url) return undefined;
  const base = url.split("?")[0];
  return widths.map((w) => `${base}?width=${w} ${w}w`).join(", ");
}

const CATALOGS_QUERY = `
  query Catalogs($after: String) {
    metaobjects(type: "catalog", first: ${PAGE_SIZE}, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        handle
        onlineStoreUrl
        heading: field(key: "heading") {
          value
        }
        date: field(key: "date") {
          value
        }
        coverImage: field(key: "cover_image") {
          reference {
            ... on MediaImage {
              image {
                url
                altText
                width
                height
              }
            }
          }
        }
      }
    }
  }
`;

function normalizeCatalog(catalog) {
  const image = catalog.coverImage?.reference?.image;
  const title = catalog.heading?.value;
  const date = catalog.date?.value;

  return {
    id: catalog.id,
    handle: catalog.handle,
    title,
    date,
    timestamp: Date.parse(date),
    url: catalog.onlineStoreUrl,
    image,
  };
}

export async function fetchCatalogs({ signal } = {}) {
  const catalogs = [];
  let after = null;
  let hasNextPage = true;

  while (hasNextPage) {
    const response = await storefront.request({
      query: CATALOGS_QUERY,
      variables: { after },
      signal,
    });

    if (response?.errors?.length) {
      throw new Error(response.errors[0].message);
    }

    const page = response?.data?.metaobjects;
    if (!page) break;

    catalogs.push(...page.nodes.map(normalizeCatalog));
    hasNextPage = page.pageInfo.hasNextPage;
    after = page.pageInfo.endCursor;
  }

  return catalogs.sort((a, b) => b.timestamp - a.timestamp);
}
